export default "__VITE_ASSET__zv7SxXhY__"